var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartLineData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.545 13.41c.23.056.467.086.705.09a3 3 0 001.672-.51l2.415 2.152a2.91 2.91 0 00-.15 2.378 3 3 0 104.778-3.27l1.905-3.818a2.834 2.834 0 002.182-.397 3 3 0 10-3.517-.285l-1.905 3.818a3 3 0 00-2.303.442l-2.415-2.152a2.91 2.91 0 00.15-2.378 3 3 0 10-4.837 3.217L3 18.75V1.5H1.5V21A1.5 1.5 0 003 22.5h19.5V21H3.503l4.042-7.59zM19.5 6a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-3 10.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM8.25 9a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
    fill: "#45464F"
  })));
}
export default SvgChartLineData;